import { isArray, keys, noop } from '@rehaje/shared'

import type { TRecord } from '@rehaje/shared'

const ShapeArrays = new WeakSet()

/**
 * FIXME：下面的用法会导致builder新表单在父子表单场景下出现值丢失的情况
 * 复现路径：点击画布空白区域选中Page节点，添加两个左侧按钮，来回下钻切换左侧按钮面板，添加事件
 * 第二个按钮面板的事件添加不成功
 */
// export function getChildrenInNArray<T = any>(
//   target: T[] & TRecord,
//   indexes: (number | string)[]
// ): T[] {
//   return getElementsInNArray(target, indexes)?.flat(Infinity) ?? []
// }
export function getChildrenInNArray<T = any>(
  target: T[] & TRecord,
  indexes: (number | string)[]
): T[] {
  let currentTarget = target

  for (const index of indexes) {
    if (isArray(currentTarget[index])) {
      currentTarget = currentTarget[index]
    } else {
      const value = currentTarget[index]
      return value === undefined ? [] : [value]
    }
  }

  if (isArray(currentTarget)) return currentTarget.flat(Infinity)

  return currentTarget === undefined ? [] : [currentTarget]
}

export function getElementInNArray<T = any>(
  target: T[] & TRecord,
  indexes: (number | string)[]
): T | undefined {
  let currentTarget = target

  for (const index of indexes) {
    if (isArray(currentTarget[index])) {
      currentTarget = currentTarget[index]
    } else {
      return currentTarget[index]
    }
  }

  while (isArray(currentTarget)) {
    currentTarget = currentTarget[0] as T[]
  }

  return currentTarget
}

export function getElementsInNArray<T = any>(
  target: T[] & TRecord,
  indexes: (number | string)[]
): T[] | undefined {
  let currentTarget = target
  for (const index of indexes) {
    if (isArray(currentTarget[index])) {
      currentTarget = currentTarget[index] as T[]
    }
  }
  return currentTarget
}

export function setNArray<T = any>(
  target: T[],
  indexes: (number | string)[],
  create: (old: T | undefined, type: number) => T = noop,
  destroy: (old: T, type: -1) => void = noop
): T {
  let pointer: any = target
  for (let i = 0; i < indexes.length; i++) {
    const index = indexes[i]
    let current = pointer[index]
    if (i === indexes.length - 1) {
      // 同维赋值
      if (isArray(current)) {
        const flattened = current.flat(Infinity)
        for (let i = flattened.length - 1; i >= 1; i--)
          destroy(flattened[i], -1)
        current = pointer[index] = create(flattened[0], -1)
      }
      // 降维赋值
      else {
        current = pointer[index] = create(current, 0)
      }
    } else {
      // 升维赋值
      if (!isArray(current)) {
        const array: any[] & TRecord = []
        const nextIndex = indexes[i + 1] ?? 0
        if (typeof nextIndex !== 'number') {
          ShapeArrays.add(array)
        }
        array[nextIndex] = create(current, 1)
        current = pointer[index] = array
      }
    }
    pointer = current
  }
  return pointer
}

export function traverseElementsInNArray<T = any>(
  target: T[] | undefined,
  visitor: (element: T, index: number | string) => void
) {
  if (!isArray(target)) return
  if (ShapeArrays.has(target)) {
    for (const key of keys(target)) {
      const item = target[key]
      if (isArray(item)) {
        traverseElementsInNArray(item, visitor)
      } else {
        visitor(item as any, key)
      }
    }
  }
  for (const [i, element] of target.entries()) {
    if (isArray(element)) {
      traverseElementsInNArray(element as T[], visitor)
    } else {
      visitor(element, i)
    }
  }
}
